import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const GiftIconThin = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>
            <path
                d="M19.3 11.8h-6.6v9.4h4.1a17.2 17.2 0 0 0 1.8 0l.5-.6.1-.5v-8.3Zm-14.6 7a17.2 17.2 0 0 0 .2 1.8l.5.5.5.1h5.3v-9.4H4.8v7ZM21.4 7.6v-.7l-.2-.1H12.8v3.5H21l.1-.2V7.6ZM2.6 9.4v.7l.2.1h8.4V6.8H2.8v2.6Zm14-5.4c0-.3 0-.7-.3-.9-.2-.2-.5-.3-.9-.4-1 0-1.6.7-2.1 1.7l-.4.8h2.5c.4 0 .7 0 .9-.3.2-.2.4-.6.4-.9Zm-9.4.1c0 .3.1.6.3.8.2.2.5.3.9.3H11l-.4-.8c-.5-1-1.2-1.7-2.1-1.7-.4 0-.7.2-.9.4-.2.2-.3.6-.3.9v.1Zm11-.1L18 5.3H21l.7.1.8.8.1.7V10l-.1.7-.8.8-.7.1h-.4v8.5c0 .4 0 .7-.2 1a2.8 2.8 0 0 1-2.3 1.5H5.8c-.4 0-.7 0-1-.2a2.8 2.8 0 0 1-1.5-2.3v-8.4h-.4l-.7-.2-.8-.8-.1-.7V7l.1-.7.8-.8.7-.1H6l-.2-1V4c0-.7.2-1.4.7-2 .5-.5 1.2-.7 2-.8 1.8 0 2.8 1.4 3.4 2.4l.1.2v-.2c.7-1 1.7-2.4 3.5-2.4.8 0 1.5.3 2 .9.5.5.8 1.2.8 1.9Z"
                fill="currentColor"
            />
        </SvgIcon>
    );
};

export default GiftIconThin;
